/* eslint-disable react/no-unescaped-entities */
import {
  Module,
  ModuleNotFoundError,
  providerFromManifest,
  useCompilationManifest,
  useModuleFederationContext,
} from '@msdk/common'
import { ApplicationError, ErrorType } from '@msdk/forms'
import { useParams } from 'react-router-dom'

export default function Custom() {
  const { moduleName } = useParams()
  const manifest = useCompilationManifest()
  const modules = useModuleFederationContext()

  let CustomComponent: (new (...args: any[]) => any) | null = null
  let msModule: Module | null = null
  let errorType: ErrorType | undefined = undefined

  try {
    const { provider } = providerFromManifest(manifest, moduleName as string)
    msModule = modules.loadedModules[provider]
    CustomComponent = msModule ? msModule[moduleName as string] : null
  } catch (e) {
    if (e instanceof ModuleNotFoundError) {
      errorType = 'BadRequest'
    } else {
      errorType = 'InternalServerError'
    }
  }

  return (
    <>
      {CustomComponent && <CustomComponent />}
      {!CustomComponent && msModule && (
        <div>
          <p>Can't find the required component inside the module ({moduleName})</p>
          <p>The module contains these entries: </p>
          <ul>
            {Object.keys(msModule).map((k) => (
              <li key={k}>{k}</li>
            ))}
          </ul>
        </div>
      )}
      {!CustomComponent && !msModule && errorType && <ApplicationError type={errorType} />}
    </>
  )
}
